export default __webpack_public_path__ + "static/media/framer.c01be520.svg";